import { useSelector } from "react-redux";
import { useMutation } from "@tanstack/react-query";

import { createAxiosInstance } from "api/axiosConfig";

export const useDownloadReceipt = () => {
  const tenantVal =
    useSelector((state) => state.auth.user?.tenant) ||
    localStorage.getItem("kinesin-tenant");

  return useMutation({
    mutationFn: async ({ consultationId, patientId }) => {
      const axiosInstance = createAxiosInstance();
      const response = await axiosInstance.get(
        `${tenantVal}/consultationpayment/receipt/consultation/${consultationId}/patient/${patientId}`,
        { responseType: "blob" }
      );
      return response.data;
    },
  });
};
